import React from 'react';
import { useTranslation } from 'react-i18next';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import { Headline } from 'ViatoUi/Shared/Typo';

import styles from './Header.module.scss';

const Header = () => {
	const { t } = useTranslation('contractGenerator');

	return (
		<div className={styles.header}>
			<Headline type='display'>{t('pages.step1.header.headline')}</Headline>
			<Spacer height='xxl' />
		</div>
	);
};

export default Header;
